import type { ReactNode } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { Spinner } from '@/components/ui'
import { appRoutes } from '@/constants'
import { useAuth } from '@/providers/auth-provider'

export interface ProtectedRouteProps {
  children?: ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <Spinner size="lg" label="Checking your session..." />
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to={appRoutes.auth.login} replace state={{ from: location.pathname }} />
  }

  return children ?? <Outlet />
}
